import React, { Suspense, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import {
  NavBar, TopBar
} from './components';

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    // background:''
  },
  topBar: {
    zIndex: 2,
    position: 'relative'
  },
  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  navBar: {
    zIndex: 3,
    width: 256,
    minWidth: 256,
    flex: '0 0 auto'
  },
  content: {
    overflowY: 'auto',
    flex: '1 1 auto'
  },
  backgroundText: {

    margin: '3rem',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: - 1,
    transform: 'rotate(300deg)',
    WebkitTransform: 'rotate(300deg)',
    color: '#c6afaf'
  }
}));

const Dashboard = props => {
  const classes = useStyles();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);

  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true);
  };

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false);
  };

  return (
    <div className={classes.root}>
      {/* <div >/Testing Env */}
      <TopBar
        className={classes.topBar}
        onOpenNavBarMobile={handleNavBarMobileOpen}
      />
      <div className={classes.container}>
        <NavBar
          className={classes.navBar}
          onMobileClose={handleNavBarMobileClose}
          openMobile={openNavBarMobile}
        />
        <main className={classes.content}>
          <Suspense fallback={<LinearProgress />}>
            {/* {renderRoutes(route.routes)} */}
            {/* <span className={classes.backgroundText}>Hiiiiiiii</span> */}
            {props.children}
          </Suspense>
        </main>
      </div>
      {/* </div> */}
      {/* <ChatBar /> */}
    </div>
  );
};

// Dashboard.propTypes = {
//   route: PropTypes.object
// };

export default Dashboard;
// export default EnhancerWaterMark({
//   content: 'Training Purpose',
//   width: '200',
//   height: '130',
//   fillStyle: 'rgba(184, 184, 184, 0.4)',
//   rotate: '24',
//   zIndex: 1000,
//   loadingOptions: {

//   },
//   //   asyncContent: '',

//   // }, {
//   //   content: 'watermark loading...',
//   //   color: 'black',
//   //   background: 'white'

// }, true)(Dashboard)